import React from "react"
import App from "./App"

import { StyledEngineProvider } from "@mui/styled-engine"
import { Provider } from "react-redux"
import store from "./redux/store"
import { render } from "react-dom"
import { BrowserRouter } from "react-router-dom"
import { CookiesProvider } from "react-cookie"

render(
  <StyledEngineProvider injectFirst>
    <React.StrictMode>
      <Provider store={store}>
        <CookiesProvider defaultSetOptions={{ path: "/" }}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </CookiesProvider>
      </Provider>
    </React.StrictMode>
  </StyledEngineProvider>,
  document.getElementById("root"),
)
